module.exports = __webpack_public_path__ + "img/files_upload.c435c2d9.svg";